import { render, staticRenderFns } from "./AddClientFormCpt.vue?vue&type=template&id=b4e89086&scoped=true&"
import script from "./AddClientFormCpt.vue?vue&type=script&lang=ts&"
export * from "./AddClientFormCpt.vue?vue&type=script&lang=ts&"
import style0 from "./AddClientFormCpt.vue?vue&type=style&index=0&id=b4e89086&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4e89086",
  null
  
)

export default component.exports